<script>
    import BookCollectionAccordianItem from './BookCollectionAccordianItem.svelte';
    import './book-accordion.css';
    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {any} [items]
     * @property {any} parentID
     * @property {any} [level]
     */
    let { items = [], parentID, level = null } = $props();

    const dispatch = createEventDispatcher();
    
    let reorderTimer = null;
    let activeItem = $state(null);
    
    function reorderChildren() {
        const nodeArr = [];
        const p = document.querySelector(`.collection-section[data-parentid="${parentID}"]`);
        if (p) {
            while (p.children.length > 0) nodeArr.push(p.removeChild(p.children.item(0)));
            nodeArr.sort((a, b) => {
                try {  
                    return a.dataset.title < b.dataset.title ? -1 : 1;
                } catch (err) {
                    console.warn(err);
                    return -1;
                }
            });
            for (const n of nodeArr) { p.appendChild(n); }
        }
    }

    function toggleItem(event) {
        dispatch('toggle', {
            itemId: event.detail.itemId
        });

        if (activeItem !== event.detail.itemId) {
            activeItem = event.detail.itemId;
        } else {
            activeItem = null;
        }
    }
    
    // monitor children and re-order
    const observer = new MutationObserver(e => {
        if (e[0].addedNodes.length > 0) {
            if (reorderTimer) clearTimeout(reorderTimer);
            reorderTimer = setTimeout(() => {
                clearTimeout(reorderTimer);
                reorderChildren();
            }, 1000);
        } 
    });

    $effect(() => {
        const tar = document.querySelector(`.collection-section[data-parentid="${parentID}"]`);
        if (tar) observer.observe(tar, { childList: true });
    });    
</script>

<ul data-parentid={parentID} class="collection-section">
    {#each items as data}
        <BookCollectionAccordianItem {data} on:toggle={toggleItem} {activeItem} {level} />
    {/each}
</ul>
